// Setup › Chart at `/c/{slug}/setup/chart` (CHART-DIMENSIONS; core, managers): the org chart's
// default dimensions and who sees each (features/chart/chart-settings.tsx).
import { createRoute } from "@tanstack/react-router";
import { ChartSettings } from "../features/chart/chart-settings";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupChartRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "chart",
  component: function Chart() {
    const { api } = setupChartRoute.useRouteContext();
    return <ChartSettings api={api} company={useCompany()} />;
  },
});
